import { type ChakraProps, Box } from "@chakra-ui/react";
import NextLink from "next/link";
import type { Ref, ReactNode } from "react";
import { forwardRef } from "react";

type Props = ChakraProps & {
  href: string;
  font?: string;
  isExternal?: boolean;
  children?: ReactNode;
};

const selectFontSize = (size = "") => {
  const fontSize =
    {
      "text-xl": ["16px", "18px"],
      "text-lg": ["14px", "16px"],
      "text-md": ["12px", "14px"],
      "text-sm": ["10px", "12px"],
    }[size] ?? undefined;

  return fontSize
    ? {
        fontSize,
        fontWeight: "bold",
      }
    : {};
};

const Link = forwardRef(
  (props: Props, ref: Ref<HTMLAnchorElement> | undefined) => {
    const { isExternal, href, ...restOfProps } = props;

    return (
      <NextLink
        href={href}
        ref={ref}
        target={isExternal ? "_blank" : "_self"}
        rel={isExternal ? "noreferrer noopener" : ""}
      >
        <Box
          onClick={(e) => e.stopPropagation()}
          wordBreak="break-all"
          {...selectFontSize(props.font)}
          {...restOfProps}
        >
          {props.children}
        </Box>
      </NextLink>
    );
  }
);

export default Link;
